import {
  UPDATE_DASHBOARD_CONFIG,
  UPDATE_DASHBOARD_CONFIG_EMPTY,
  UPDATE_DASHBOARD_CONFIG_ERROR,
  UPDATE_DASHBOARD_CONFIG_SUCCESS,
} from '../../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateDashboardConfig = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DASHBOARD_CONFIG:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_DASHBOARD_CONFIG_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_DASHBOARD_CONFIG_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_DASHBOARD_CONFIG_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateDashboardConfig;
